import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '../../../store/reducers';
import { getSelected } from '../../../store/reducers/user';
import { AppUser } from '../../../models/user.model';
import { TemplateMessages } from '../../configs/template.messages';
import { MatDialog } from '@angular/material/dialog';
import { TaskDialogComponent } from '../../../components/admin/shared/dialogs/task-dialog/task-dialog.component';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnDestroy {

    // currentLang = 'ru';
    toggleClass = 'ft-maximize';
    placement = 'bottom-right'
    public isCollapsed = true;
    user: AppUser = <AppUser>{};
    roleName: string;
    private subscriber: any;

    constructor(public translate: TranslateService,
                private dialog: MatDialog,
                private store: Store<fromRoot.AppState>) {
        const browserLang: string = translate.getBrowserLang();
        translate.use(browserLang.match(/en|es|pt|de/) ? browserLang : 'en');

        this.subscriber = this.store.pipe(select(fromRoot.selectUserState()))
        .subscribe((state: any) => {
            this.user = getSelected(state);
            this.roleName = this.user && this.user.isAdmin ? TemplateMessages.SUPERADMIN_ROLE_NAME : (this.user ? this.user.roleName : this.roleName);
        });
    }

    ChangeLanguage(language: string) {
        this.translate.use(language);
    }

    ToggleClass() {
        if (this.toggleClass === 'ft-maximize') {
            this.toggleClass = 'ft-minimize';
        } else {
          this.toggleClass = 'ft-maximize';
        }
    }

    ngOnDestroy() {
      this.subscriber.unsubscribe();
    }

    openNewTaskDialog() {
     this.dialog.open(TaskDialogComponent, { width: '50%'});
    }

}
